import React, { useEffect, useState } from "react";
import "./SectionProchainMatch.css";
import { fetchNextMatche } from "../../ServiceApi";

const SectionProchainMatch = () => {
    const [nextMatch, setNextMatch] = useState(null);

    useEffect(() => {
        const fetchNextMatch = async () => {
            const clubId = 137104; // ID du club
            const today = new Date();
            const todayDate = today.toISOString().split("T")[0];

            try {
                // Appeler l'API sans le paramètre "before" pour récupérer les prochains matchs
                const matches = await fetchNextMatche(clubId, todayDate, null);
                // Trouver le premier match futur
                const futureMatch = matches.find(match => {
                    return (
                        match.home_score === null && // Le match n'est pas encore joué
                        match.away_score === null &&
                        match.competition.name.trim().toLowerCase() === "D2 FUTSAL".toLowerCase() // Vérifier que c'est en Régional 1
                    );
                });
                setNextMatch(futureMatch || null); // Si aucun match, définir à null
            } catch (error) {
                console.error("Erreur lors de la récupération du prochain match :", error);
                setNextMatch(null);
            }
        };

        fetchNextMatch();
    }, []);

    if (!nextMatch) {
        return (
            <div id="prochain-match" className="section-next-match">
                <h2 className="section-title">Prochain Match</h2>
                <div className="no-next-match">Aucun prochain match programmé.</div>
            </div>
        );
    }

    return (
        <div id="prochain-match" className="section-next-match">
            <h2 className="next-match-title">Prochain Match</h2>
            <div className="next-match-card">
                <div className="next-match-header">
                    {nextMatch.competition.name.toUpperCase()} - {nextMatch.poule_journee.name} journée
                </div>
                <div className="next-match-body">
                    <div className="equipe">
                        <img
                            src={nextMatch.home.club.logo}
                            alt={`Logo de ${nextMatch.home.short_name}`}
                            className="equipe-logo"
                        />
                        <span>{nextMatch.home.short_name}</span>
                    </div>
                    <div className="vs">VS</div>
                    <div className="equipe">
                        <img
                            src={nextMatch.away.club.logo}
                            alt={`Logo de ${nextMatch.away.short_name}`}
                            className="equipe-logo"
                        />
                        <span>{nextMatch.away.short_name}</span>
                    </div>
                </div>
                <div className="next-match-footer">
                    <div className="match-date">
                        {new Date(nextMatch.date).toLocaleDateString()} à {nextMatch.time || "Horaire non défini"}
                    </div>
                    <div className="match-location">{nextMatch.terrain?.name || "Lieu non défini"}</div>
                </div>
            </div>
        </div>
    );
};

export default SectionProchainMatch;
